import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Table } from 'reactstrap';

import EmptySurveyIcon from 'assets/img/empty-survey-icon.png';
import Toaster from 'components/Toaster';
import BusinessApi from 'apis/Business';
import 'assets/scss/surveyTemplate.css';
import {
  getBusinessId,
  setSuggestedTemplate,
} from '../../constants/localStorageManager';

class EmptySurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestedTemplates: [],
      isFetching: false,
    };
  }

  componentDidMount() {
    this.fetchSuggestedTemplates();
  }

  fetchSuggestedTemplates = () => {
    const { id } = this.props.match.params;
    const businessId = id || getBusinessId();
    this.setState({ isFetching: true });
    BusinessApi.getSuggestedSurvey(businessId)
      .then(({ data }) => {
        this.setState({ suggestedTemplates: data, isFetching: false });
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Error while fetching survey templates'
        );
        this.setState({ isFetching: false });
      });
  };

  onTemplateSelected = template => {
    const { onAddSurvey } = this.props;
    setSuggestedTemplate(template);
    onAddSurvey();
  };

  render() {
    const { onAddSurvey } = this.props;
    const { suggestedTemplates, isFetching } = this.state;
    const suggestedSurveyTemplates = suggestedTemplates.map(surveyTemplate => {
      const surveyName = surveyTemplate.name;
      return (
        <tr
          className="cursor-pointer"
          onClick={() => this.onTemplateSelected(surveyTemplate)}
        >
          <th className="fw-400">
            {surveyName}
            <span>
              <FontAwesomeIcon
                icon="angle-right"
                className="float-right mt-1"
              />
            </span>
          </th>
        </tr>
      );
    });

    const tableBody = suggestedSurveyTemplates.length ? (
      suggestedSurveyTemplates
    ) : (
      <tr>
        <th className="fw-400">
          {isFetching ? (
            <div>
              <FontAwesomeIcon icon="spinner" pulse /> Fetching suggestions
            </div>
          ) : (
            'No suggestions found'
          )}
        </th>
      </tr>
    );

    return (
      <div>
        <main role="main">
          <div className="container">
            <div className="row mb-4">
              <div className="col-md-8">
                <div className="bg-white styled-box-shadow centered-empty-icon">
                  <img
                    src={EmptySurveyIcon}
                    className="mb-3"
                    title="Empty Survey"
                    alt="Empty Survey Icon"
                  />
                  <h5 className="text-center mb-4">
                    Your survey list is empty!
                  </h5>
                  <button
                    onClick={onAddSurvey}
                    className="btn btn-add btn-light btn-add-new d-block mx-auto d-block col-md-4"
                  >
                    <FontAwesomeIcon icon="plus" /> Add a new survey
                  </button>
                  <p className="text-center text-bold mt-3">
                    Or use a suggested survey template to get started!
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <Table
                  hover
                  id="categoryTable"
                  className="styled-box-shadow left-nav-box"
                >
                  <thead>
                    <tr>
                      <th>Suggested Templates</th>
                    </tr>
                  </thead>
                  <tbody>{tableBody}</tbody>
                  <thead className="bottom-attached-btn text-center bg-white secondary-text">
                    {/* <Link to="\" className="d-block p-3">View more</Link> */}
                  </thead>
                </Table>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

EmptySurvey.defaultProps = {
  onAddSurvey: () => {},
};

EmptySurvey.propTypes = {
  onAddSurvey: PropTypes.func,
};

export default withRouter(EmptySurvey);



// WEBPACK FOOTER //
// ./src/components/surveys/EmptySurvey.js